import { render, staticRenderFns } from "./return-policy.vue?vue&type=template&id=1c5451b4&"
import script from "./return-policy.vue?vue&type=script&lang=js&"
export * from "./return-policy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LegalPageWrapper: require('/opt/build/repo/apps/shop/components/LegalPageWrapper.vue').default})
